import sortBy from 'lodash/sortBy'
import { observer } from 'mobx-react'

import { PhotoCompletion } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'
import {
  CaseColumnNames,
  CaseFilterIds,
} from '@new/domains/operations/screens/CasesV2/utils/config'
import { parseLabel } from '@new/domains/operations/utils/parseLabel'

import { CheckBoxWrapper } from './commonFilterStyles.style'

const _PhotoCompletionFilter = () => {
  const { setFilterValue, photoCompletion } = casesFiltersStore

  const handleDataFilter = (value?: string[] | undefined) => {
    setFilterValue(CaseFilterIds.PhotoCompletion, value)
  }

  const options = sortBy(
    Object.values(PhotoCompletion).map(value => ({
      label: parseLabel(value),
      value: value,
      hasFullWidth: true,
    })),
    'label'
  )

  return (
    <CheckBoxWrapper>
      <CheckboxBasedFilter
        title={CaseColumnNames.PhotoCompletion}
        options={options}
        initialValue={photoCompletion}
        onChange={handleDataFilter}
      />
    </CheckBoxWrapper>
  )
}

export const PhotoCompletionFilter = observer(_PhotoCompletionFilter)
